import { render, staticRenderFns } from "./challengingordermanagementcenter.vue?vue&type=template&id=6c1dc27e&scoped=true&"
import script from "./challengingordermanagementcenter.vue?vue&type=script&lang=js&"
export * from "./challengingordermanagementcenter.vue?vue&type=script&lang=js&"
import style0 from "./challengingordermanagementcenter.vue?vue&type=style&index=0&id=6c1dc27e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1dc27e",
  null
  
)

export default component.exports